import { render } from "./AlertUserNotFound.vue?vue&type=template&id=081c6c74&scoped=true"
import script from "./AlertUserNotFound.vue?vue&type=script&lang=js"
export * from "./AlertUserNotFound.vue?vue&type=script&lang=js"

import "./AlertUserNotFound.vue?vue&type=style&index=0&id=081c6c74&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081c6c74"]])

export default __exports__